import { render, staticRenderFns } from "./AppSubmenu.vue?vue&type=template&id=39bc5bb0&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc5bb0",
  null
  
)

export default component.exports